import { createApi } from '@reduxjs/toolkit/query/react';

import baseQuery from 'src/utils/baseQuery';

export interface ChannelListType {
  channelName: string;
  channelType: string;
  configId: string;
  createdAt: string;
  id: string;
  teamId: string | null;
  tenantId: string;
  updatedAt: string;
}

export const channelApi = createApi({
  reducerPath: 'channelApi',
  baseQuery,
  endpoints: (builder) => ({
    getChannelList: builder.mutation({
      query: (channelPayload) => ({
        url: 'channel/list',
        method: 'POST',
        body:
          Object.keys(channelPayload).length > 0
            ? channelPayload
            : {
                filters: [],
              },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: {
        data?: { channel?: { list?: ChannelListType[]; total: number } };
      }) => ({
        list: response?.data?.channel?.list ?? [],
        total: response?.data?.channel?.total ?? 0,
      }),
    }),
    createChannel: builder.mutation({
      query: (newChannel) => ({
        url: 'channel/add',
        method: 'POST',
        body: newChannel,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    filterChannel: builder.mutation({
      query: (filterQuery) => ({
        url: 'channel/list',
        method: 'POST',
        body: filterQuery,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: {
        data?: { channel?: { list?: ChannelListType[]; total: number } };
      }) => ({
        list: response?.data?.channel?.list ?? [],
        total: response?.data?.channel?.total ?? 0,
      }),
    }),
    updateChannel: builder.mutation({
      query: (updateQuery) => ({
        url: `channel/update`,
        method: 'POST',
        body: updateQuery,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    getChannelDeatil : builder.mutation({
      query:(id) =>({
        url: `channel/details`,
        method: 'POST',
        body: {id},
        headers: {
          'Content-Type': 'application/json',
        },
      })
    }),
    deleteChannels: builder.mutation({
      query: (ids: string[]) => ({
        url: `channel/delete`,
        method: 'POST',
        body: { ids },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    sendIVRRequest: builder.mutation({
      query: (ivrPayload) => ({
        url: `channel/sendMail`,
        method: 'POST',
        body: ivrPayload,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    sendDIDRequest: builder.mutation({
      query: (didPayload) => ({
        url: `channel/sendMail`,
        method: 'POST',
        body: didPayload,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    })
  }),
});

export const {
  useGetChannelListMutation,
  useCreateChannelMutation,
  useFilterChannelMutation,
  useUpdateChannelMutation,
  useGetChannelDeatilMutation,
  useDeleteChannelsMutation,
  useSendIVRRequestMutation,
  useSendDIDRequestMutation
} = channelApi;
